import {Action} from '@ngrx/store';
import {SubscriptionModel} from '../subscription.model';
import {SubscriptionItemModel} from '../subscription-item.model';

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTION_LIST';
export const SAVE_SUBSCRIPTIONS = 'SAVE_SUBSCRIPTION_LIST';
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
export const SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION';
export const UPDATE_LOCAL_SUBSCRIPTION = 'UPDATE_LOCAL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const GET_SUBSCRIPTION_ITEMS = 'GET_SUBSCRIPTION_ITEMS';
export const SAVE_SUBSCRIPTION_ITEMS = 'SAVE_SUBSCRIPTION_ITEMS';

export class GetSubscriptions implements Action {
  readonly type = GET_SUBSCRIPTIONS;

  constructor(public payload: {params: any}) {
  }
}

export class SaveSubscriptions implements Action {
  readonly type = SAVE_SUBSCRIPTIONS;

  constructor(public payload: SubscriptionModel[]) {
  }
}

export class GetSubscription implements Action {
  readonly type = GET_SUBSCRIPTION;

  constructor(public payload: {id: number}) {
  }
}

export class SaveSubscription implements Action {
  readonly type = SAVE_SUBSCRIPTION;

  constructor(public payload: SubscriptionModel) {
  }
}

export class UpdateLocalSubscription implements Action {
  readonly type = UPDATE_LOCAL_SUBSCRIPTION;

  constructor(public payload: { id: number, keyName: string, value: any }) {
  }
}

export class CancelSubscription implements Action {
  readonly type = CANCEL_SUBSCRIPTION;

  constructor(public payload: {id: number}) {
  }
}

export class GetSubscriptionItems implements Action {
  readonly type = GET_SUBSCRIPTION_ITEMS;

  constructor(public payload: {id: number}) {
  }
}

export class SaveSubscriptionItems implements Action {
  readonly type = SAVE_SUBSCRIPTION_ITEMS;

  constructor(public payload: SubscriptionItemModel[]) {
  }
}

export type SettingActions = GetSubscriptions | SaveSubscriptions | GetSubscription | SaveSubscription | GetSubscriptionItems
  | SaveSubscriptionItems | CancelSubscription | UpdateLocalSubscription;
